/*
 * @Author: Hong.Zhang
 * @Date: 2025-02-12 10:34:09
 * @Description:
 */
import qs from 'qs';

export const getParamsFromQuery = (): {
  kredivoUserId: string;
  locale: string;
  firstAuthToken: string;
} => {
  const search = location.search;
  const params = qs.parse(search.substring(1));
  const { kredivo_user_id = '', locale = '', token = '' } = params;
  return {
    kredivoUserId: kredivo_user_id as string,
    locale: locale as string,
    firstAuthToken: token as string,
  };
};
